import React from 'react'

export default function InfluencerLogin() {

  return (
    <div>
      InfluencerLogin
    </div>
  )
}